import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

const styles = theme => ({
  grid: {
    padding: theme.spacing(5),
  },
  instructions: {
    paddingBottom: theme.spacing(2),
  },
  noPaymentText: {
    padding: theme.spacing(2),
    textAlign: 'center',
  },
});

function PaymentForm(props) {
  const {
    classes,
    shippingMethods,
    activeShippingMethod,
    handleShippingMethodChange,
  } = props;

  return (
    <React.Fragment>
      <Grid container className={classes.grid} spacing={3}>
        <Grid item xs={6}>
          <Typography variant="h6">Shipping Method</Typography>
          <FormControl component="fieldset" className={classes.formControl}>
            <RadioGroup aria-label="shipping-methods" name="shipping-methods" value={activeShippingMethod} onChange={handleShippingMethodChange}>
              {shippingMethods.map(shipMethod => (
                <FormControlLabel
                  key={shipMethod.name}
                  value={shipMethod.name}
                  control={<Radio />}
                  label={shipMethod.name + ' $' + (shipMethod.price.excl_tax == null ? ' Shipping Error! Nia Staff will contact you with amount' : shipMethod.price.excl_tax)}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

PaymentForm.propTypes = {
  classes: PropTypes.object.isRequired,
  shippingRequired: PropTypes.bool.isRequired,
  shippingMethods: PropTypes.array.isRequired,
  activeShippingMethod: PropTypes.string.isRequired,
  handleShippingMethodChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(PaymentForm);
